const { log } = console
const HistoryItem = require('./utils/history-item.js')
const { findTargetById } = require('./utils/find-target.js')
const uuid = require('./utils/uuid.js')
module.exports = function store (state, emitter) {
  emitter.on('drop-to-all', () => {
    const fromTarget = findTargetById(state.vm, state.selectedTargetId)
    const glitchApplication = state.glitchApplications.find(
      g => g.id === state.selectedGlitchApplicationId
    )
    const otherSprites = state.vm.runtime.targets.filter(
      t => t.sprite !== fromTarget.sprite
        && t.isOriginal
        && !t.isStage
    )
    const historyItem = HistoryItem(
      {
        actionType: 'drop-to-all',
        glitchId: glitchApplication.glitchId
      }
    )
    const glitchVariables = glitchApplication.targetVarNames.map(v => {
      const varName = v.name
      let variable
      if (v.type === 'list') {
        variable = fromTarget.lookupOrCreateList(uuid(), varName)
      } else {
        variable = fromTarget.lookupOrCreateVariable(uuid(), varName)
      }
      return { name: varName, value: variable.value, type: variable.type }
    })
    state.vm.runtime.targets.filter(
      t => t !== fromTarget && !t.isStage
    ).forEach(toTarget => {
      glitchVariables.forEach(glitchVar => {
        toTarget.sprite.clones.forEach(c => {
          const v = c.lookupOrCreateVariable(uuid(), glitchVar.name)
          v.value = glitchVar.value
        })
      })
    })
    emitter.emit('push-history', historyItem)
    otherSprites.forEach(sprite => {
      emitter.emit('apply-glitch', glitchApplication.glitchId, sprite.id)
    })
    emitter.emit('select-glitch-application', glitchApplication.id)
    log('drop-to-all')
  })
}
